import { render, staticRenderFns } from "./ms-return-num.vue?vue&type=template&id=e77252c0&scoped=true"
import script from "./ms-return-num.vue?vue&type=script&lang=js"
export * from "./ms-return-num.vue?vue&type=script&lang=js"
import style0 from "./ms-return-num.vue?vue&type=style&index=0&id=e77252c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77252c0",
  null
  
)

export default component.exports